import script from "./SearchModule.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchModule.vue?vue&type=script&setup=true&lang=js"

import "./SearchModule.vue?vue&type=style&index=0&id=5aff5cfc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aff5cfc"]])

export default __exports__